var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkyscraper4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0002H2.66667M14 14.0002H13.3333M2.66667 14.0002V5.77794C2.66667 4.7961 3.46261 4.00016 4.44444 4.00016V4.00016C4.93536 4.00016 5.33333 3.60219 5.33333 3.11127V3.11127C5.33333 2.12943 6.12927 1.3335 7.11111 1.3335L8 1.3335C8.61998 1.3335 8.92997 1.3335 9.1843 1.40164C9.87449 1.58658 10.4136 2.12567 10.5985 2.81586C10.6667 3.07019 10.6667 3.38018 10.6667 4.00016V5.3335M2.66667 14.0002H10.6667M10.6667 14.0002V5.3335M10.6667 14.0002H13.3333M10.6667 5.3335H11.7333C12.2934 5.3335 12.5734 5.3335 12.7873 5.44249C12.9755 5.53836 13.1285 5.69134 13.2243 5.87951C13.3333 6.09342 13.3333 6.37344 13.3333 6.9335V14.0002",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 6.6665H7.99992M5.33325 8.99984H7.99992M5.33325 11.3332H7.99992",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.34016V4.3335",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyscraper4);
export default __webpack_public_path__ + "static/media/skyscraper-4.986c68b76844b8cdd19fd615f43d9093.svg";
export { ForwardRef as ReactComponent };